import gsap from 'gsap'
import { getLenis } from '@js/animations/Scroll'
import { reduceMotion } from '@js/animations/ReducedMotion'

export class Header {
  constructor() {
    this._header = document.querySelector('header')
    this._hero = document.querySelector('.s-hero')
    this._burger = document.querySelector('#burger')
    this._mobileMenu = document.querySelector('.h-nav__mobile')
    this._scrollValue = 0
    this._itemsWithChildren = document.querySelectorAll('.menu-item-has-children')

    this._heroHeight = this._hero ? this._hero.clientHeight : 0

    if (this._hero) {
      this.scroll()
    }

    if (this._itemsWithChildren.length) {
      this._itemsWithChildren.forEach(item => {
        this.handleSubmenu(item)
      })
    }

    if (this._burger) {
      this._burger.addEventListener('click', this.handleBurger)
    }

    if (this._header) {
      document.body.style.setProperty('--header-offset', `${this._header.offsetHeight}px`)
    }

    const lenis = getLenis()

    if (lenis) {
      lenis.on('scroll', this.scroll)
    } else {
      window.addEventListener('scroll', this.scroll)
    }
  }

  handleBurger = () => {
    this._mobileMenu.classList.toggle('is-active')
  }

  scroll = () => {
    if (!this._header) {
      return
    }

    const lenis = getLenis()
    this._scrollValue = lenis ? lenis.scroll : window.scrollY

    if (this._scrollValue > this._heroHeight) {
      this._header.classList.add('scrolled')
    } else {
      this._header.classList.remove('scrolled')
    }
  }

  handleSubmenu = (item) => {

    const submenu = item.querySelector('.sub-menu')
    const link = item.querySelector(':scope > a')
    const isMobile = /Mobi|Android/i.test(navigator.userAgent)

    let clicked = false

    link.addEventListener('click', (e) => {
      if (isMobile && !clicked) {
        e.preventDefault()
      }
      clicked = !clicked
    })

    if (reduceMotion) {
      item.addEventListener('mouseover', () => {
        gsap.set(submenu, { height: 'auto', autoAlpha: 1 })
      })

      item.addEventListener('mouseleave', () => {
        gsap.set(submenu, { height: 0, autoAlpha: 0 })
        clicked = false
      })

      return
    }

    const openAnimation = gsap.to(submenu, {
      height: 'auto',
      duration: 0.5,
      autoAlpha: 1,
      ease: 'power2.inOut',
      paused: true,
    })

    item.addEventListener('mouseover', () => {
      openAnimation.play()
    })

    item.addEventListener('mouseleave', () => {
      openAnimation.reverse()
      clicked = false
    })

  }

}
